export default __webpack_public_path__ + "static/wood-offer-e83ff3f956180a4e7009d3e8456b279c.png";